import { render, staticRenderFns } from "./orderPageAddrMsgPoin.vue?vue&type=template&id=32e09baa&scoped=true"
import script from "./orderPageAddrMsgPoin.vue?vue&type=script&lang=js"
export * from "./orderPageAddrMsgPoin.vue?vue&type=script&lang=js"
import style0 from "./orderPageAddrMsgPoin.vue?vue&type=style&index=0&id=32e09baa&prod&lang=scss"
import style1 from "./orderPageAddrMsgPoin.vue?vue&type=style&index=1&id=32e09baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e09baa",
  null
  
)

export default component.exports